/* eslint-disable */
export default {
  feedbackHeader: '피드백 제출',
  back: '뒤로',
  revert: '되돌리기',
  instruction:
    '피드백은 매우 중요합니다. 앱을 사용하는 데 문제가 있거나 기능을 요청하거나 버그를 신고하려는 경우 기꺼이 도와 드리겠습니다.',
  fillForm: '아래 양식에 입력한 후 클릭하세요. ',
  useMailBox: ' 또는 직접 사서함을 사용하여 요청을 다음 주소로 보내세요. ',
  email: '전자 메일 주소',
  reply: '(귀하에게 회신할 수 있도록)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: '피드백 주제',
  topicPlaceHolder: '옵션을 선택하세요.',
  bugReport: '버그 신고',
  featureRequest: '기능 요청',
  others: '기타',
  subject: '제목',
  subjectPlaceHolder: '도움이 필요한 사항을 알려 주세요.',
  description: '전체 설명',
  descriptionPlaceHolder: '최대한 많은 정보를 입력하세요.',
  send: '피드백 보내기',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
